import Vue from 'vue';

export const Bus = new Vue();


// WEBPACK FOOTER //
// ./src/bus.js